/*eslint-disable*/
import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Button from "components/CustomButtons/Button.js";
import Footer from "components/Footer/Footer.js";

import {Facebook} from "@material-ui/icons";
import {Instagram} from "@material-ui/icons";
import {Twitter} from "@material-ui/icons";

import FooterStyle from "sections/Footer/FooterStyle";


const useStyles = makeStyles(FooterStyle);

const FooterSection = () => {
    const classes = useStyles();
    return (
        <Footer
            theme="transparent"
            content={
                <div>
                    <div className={classes.left}>
                        <span
                            href="https://classcar.kr"
                            target="_blank"
                            className={classes.footerBrand} style={{color: 'white'}}
                        >
                            <img style={{width: 91, height: 50, objectFit: 'cover', objectPosition: 'center', marginTop: -20}}  src={require('assets/img/footer_logo.svg')} alt="Logo" />
                        </span>
                    </div>
                    <div className={classes.pullCenter}></div>
                    <div className={classes.rightLinks}>
                        <ul>
                            <li>
                                <Button
                                    target="_blank"
                                    color="github"
                                    justIcon
                                    simple
                                >
                                    <Facebook />
                                </Button>
                            </li>
                            <li>
                                <Button
                                    target="_blank"
                                    color="github"
                                    justIcon
                                    simple
                                >
                                    <Instagram />
                                </Button>
                            </li>
                            <li>
                                <Button
                                    target="_blank"
                                    color="github"
                                    justIcon
                                    simple
                                >
                                    <Twitter />
                                </Button>
                            </li>
                        </ul>
                    </div>
                </div>
            }
        />
    );
};

export default FooterSection;
